import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useGetAliveQuery } from '../alive/aliveEndpoints';

const webBuildNumber = import.meta.env.VITE_BUILD_NUMBER ?? 'local';

/**
 * A small muted footer linking to the API status page (SCF-D1), with the web build and, once
 * `/alive` answers, the API build (QZ-D47).
 */
export const Footer = () => {
  const { t } = useTranslation();
  const { data } = useGetAliveQuery();

  return (
    <footer className="qz-footer">
      <div className="qz-container">
        <span>{t('nav.appName')}</span>
        <Link to="/alive">{t('footer.apiStatus')}</Link>
        <span className="ms-auto qz-mono">
          {data
            ? t('footer.builds', { webBuild: webBuildNumber, apiBuild: data.buildNumber })
            : t('footer.webBuild', { webBuild: webBuildNumber })}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
